module.exports = __webpack_public_path__ + "static/media/nile.2018af11.jpeg";